import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@follosoft/react-components";
import { OnlinePaymentOptionsResource, PaymentTiming } from "@/interfaces";

export function useOnlinePaymentOptions(
  contractId?: number | string,
  paymentPlanId?: number | string,
  promotionId?: number | string,
  paymentTiming?: PaymentTiming,
  payInFull?: boolean
) {
  return useQuery<OnlinePaymentOptionsResource>({
    queryKey: [
      "online-payment-options",
      Number(contractId),
      Number(paymentPlanId),
      Number(promotionId),
      paymentTiming ?? null,
      payInFull ?? false,
    ],
    queryFn: async () => {
      if (!contractId || !paymentPlanId) return [];

      const params = {
        ...(promotionId ? { promotionId: Number(promotionId) } : {}),
        ...(paymentTiming ? { paymentTiming } : {}),
        // Only sent when taken: the API defaults to the plan's own schedule, and a
        // plan that never offered this ignores it either way.
        ...(payInFull ? { payInFull: 1 } : {}),
      };

      const res = await axiosInstance().get(
        `/folloportal/contracts/${contractId}/online-payment/${paymentPlanId}/options`, {
          params: Object.keys(params).length ? params : undefined
        }
      );

      return res.data;
    },
    enabled: !!contractId && !!paymentPlanId,
    staleTime: 0,
  });
}
